import axios from "axios";

export const state = {
    maternitypatients: [],
};

export const getters = {
    maternitypatients: state => state.maternitypatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.maternitypatients = newValue
    },
};

export const actions = {
    fetchMaternityPatients({ commit }) {
        axios.get('/maternitypatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterMaternityPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtermaternitypatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
